export const allProjectSourceAndEmploymentCategories = [
	{
		id: 20,
		name: "Self-Initiated: Practice Project",
		category: "Project Source",
	},
	{
		id: 2,
		name: "Self-Initiated: Personal Startup",
		category: "Project Source",
	},
	{
		id: 121,
		name: "Self-Initiated: Speculative",
		category: "Project Source",
	},
	{
		id: 5,
		name: "Self-Initiated: Open Source Contribution",
		category: "Project Source",
	},
	{ id: 1, name: "Client-Requested", category: "Project Source" },
	{ id: 3, name: "Referral-Based", category: "Project Source" },
	{ id: 4, name: "Agency-Based", category: "Project Source" },

	{ id: 100, name: "Personal", category: "Project Class" },
	{ id: 111, name: "Client-work", category: "Project Class" },

	{ id: 600, name: "Self Employed", category: "Employment Status" },
	{ id: 700, name: "Employed", category: "Employment Status" },

	{ id: 9, name: "Freelance", category: "Work Mode" },
	{ id: 10, name: "Contract-Based", category: "Work Mode" },
	{ id: 11, name: "Full-Time Job", category: "Work Mode" },
	{ id: 12, name: "Internship", category: "Work Mode" },

	{ id: 6, name: "Paid", category: "Payment Type" },
	{ id: 7, name: "Unpaid", category: "Payment Type" },
	{ id: 8, name: "Partially Paid", category: "Payment Type" },

	{ id: 13, name: "One-Time Work", category: "Client Relationship" },
	{
		id: 14,
		name: "Ongoing Support",
		category: "Client Relationship",
	},
];
export const allProjectCategories = [
	// ===

	{
		id: 150,
		name: "Software Development",
		category: "Project Type",
	},
	{
		id: 160,
		name: "UI Design",
		category: "Project Type",
	},
	{
		id: 170,
		name: "UX design",
		category: "Project Type",
	},

	{
		id: 150,
		name: "Full-Stack Development",
		category: "Software Development Type",
	},
	{
		id: 160,
		name: "Front-End Development",
		category: "Software Development Type",
	},
	{
		id: 170,
		name: "Back-End Development",
		category: "Software Development Type",
	},

	// type of software I built
	{
		id: 151,
		name: "Website",
		category: "Software Category",
	},
	{
		id: 15,
		name: "Web Application",
		category: "Software Category",
	},
	{
		id: 16,
		name: "Mobile Application",
		category: "Software Category",
	},
	{
		id: 17,
		name: "Desktop application",
		category: "Software Category",
	},
	{
		id: 18,
		name: "AI/ML Development",
		category: "Software Category",
	},
	{
		id: 19,
		name: "Game Development",
		category: "Software Category",
	},
	{
		id: 20,
		name: "Embedded Systems",
		category: "Software Category",
	},

	{ id: 21, name: "E-commerce", category: "Industry Focus" },
	{ id: 22, name: "Fintech", category: "Industry Focus" },
	{ id: 23, name: "Healthcare", category: "Industry Focus" },
	{ id: 24, name: "Education", category: "Industry Focus" },
	{
		id: 25,
		name: "Nonprofit & Social Impact",
		category: "Industry Focus",
	},
	{
		id: 26,
		name: "Entertainment & Media",
		category: "Industry Focus",
	},

	{
		id: 27,
		name: "MVP (Minimum Viable Product)",
		category: "Project Scale",
	},
	{ id: 28, name: "Startup Project", category: "Project Scale" },
	{ id: 29, name: "Enterprise Software", category: "Project Scale" },
	{ id: 30, name: "Personal Project", category: "Project Scale" },
];
//! types of websites/application that can be built == grouped
export const categoriesOfProductBuilt = [
	// type of software I built
	{
		id: 151,
		name: "Website",
		category: "Product Category",
	},
	{
		id: 152,
		name: "Application Software",
		category: "Product Category",
	},
	{
		id: 15,
		name: "Web Application",
		category: "Software Category",
	},
	{
		id: 16,
		name: "Mobile Application",
		category: "Software Category",
	},
	{
		id: 17,
		name: "Desktop application",
		category: "Software Category",
	},
	{
		id: 18,
		name: "AI/ML Development",
		category: "Software Category",
	},
	{
		id: 19,
		name: "Game Development",
		category: "Software Category",
	},
	{
		id: 20,
		name: "Embedded Systems",
		category: "Software Category",
	},

	{ id: 21, name: "Company", category: "Industry Focus" },
	{ id: 212, name: "E-commerce", category: "Industry Focus" },
	{ id: 213, name: "Portfolio", category: "Industry Focus" },
	{ id: 214, name: "Landing Page", category: "Industry Focus" },
	{ id: 215, name: "Waitlist", category: "Industry Focus" },
	//
	{ id: 22, name: "Fintech", category: "Industry Focus" },
	{ id: 221, name: "Banking and Finance", category: "Industry Focus" },
	{ id: 222, name: "Stock Market and Trading", category: "Industry Focus" },
	{ id: 223, name: "Cryptocurrency", category: "Industry Focus" },
	//
	{ id: 23, name: "Healthcare", category: "Industry Focus" },
	{ id: 23, name: "Healthcare", category: "Industry Focus" },
	//
	{ id: 24, name: "Education", category: "Industry Focus" },
	{ id: 241, name: "E-learning platform", category: "Industry Focus" },
	{ id: 242, name: "University", category: "Industry Focus" },
	{
		id: 243,
		name: "Documentation and Wiki Sites",
		category: "Industry Focus",
	},
	//
	{
		id: 25,
		name: "Nonprofit & Social Impact",
		category: "Industry Focus",
	},
	{
		id: 251,
		name: "Government",
		category: "Industry Focus",
	},
	{
		id: 252,
		name: "Charity and Nonprofit",
		category: "Industry Focus",
	},
	//
	{
		id: 26,
		name: "Entertainment & Media",
		category: "Industry Focus",
	},

	// project scale
	{
		id: 27,
		name: "MVP (Minimum Viable Product)",
		category: "Project Scale",
	},
	{ id: 28, name: "Startup Project", category: "Project Scale" },
	{ id: 29, name: "Enterprise Software", category: "Project Scale" },
	{ id: 30, name: "Personal Project", category: "Project Scale" },
];
//! every role involved in building the above selected product
//! types of websites/application that can be built == grouped
export const categoriesOfRolesPlayedInProject = [
	// ===

	{
		id: 10,
		name: "Product Management",
		category: "Project Type",
	},
	{
		id: 11,
		name: "Project Management",
		category: "Project Type",
	},
	{
		id: 12,
		name: "UI Design",
		category: "Project Type",
	},
	{
		id: 13,
		name: "UX design",
		category: "Project Type",
	},
	{
		id: 130,
		name: "Web Design",
		category: "Project Type",
	},
	{
		id: 140,
		name: "Development",
		category: "Project Type",
	},
	{
		id: 141,
		name: "Web Development",
		category: "Project Type",
	},
	{
		id: 142,
		name: "Software Development",
		category: "Project Type",
	},
	{
		id: 150,
		name: "Full-Stack Development",
		category: "Software Development Type",
	},
	{
		id: 160,
		name: "Front-End Development",
		category: "Software Development Type",
	},
	{
		id: 170,
		name: "Back-End Development",
		category: "Software Development Type",
	},

	//
	{
		id: 18,
		name: "AI/ML Development",
		category: "Software Category",
	},
	{
		id: 19,
		name: "Game Development",
		category: "Software Category",
	},
	// {
	// 	id: 20,
	// 	name: "Embedded Systems",
	// 	category: "Software Category",
	// },
];

// allProjectSourceAndEmploymentCategories
export const getSelectedCategoriesArr = (options: {
	from: "project source" | "product built" | "roles played in project";
	projectCategoryFromDB: string[];
}) => {
	if (!options.projectCategoryFromDB) {
		return [];
	}

	let categoryList: any = [];
	switch (options.from) {
		case "project source":
			categoryList = allProjectSourceAndEmploymentCategories;
			break;

		case "product built":
			categoryList = categoriesOfProductBuilt;
			break;

		case "roles played in project":
			categoryList = categoriesOfRolesPlayedInProject;
			break;

		default:
			break;
	}

	return categoryList.filter((item: any) =>
		options.projectCategoryFromDB.includes(item.name)
	);
};
